<div class="formgrid grid">
  <!-- Tipo Via -->
  <div class="field col-12 md:col-4">
    <label class="font-semibold block mb-2">
      Tipo Via
      <span class="text-red-500" aria-hidden="true">*</span>
    </label>
    <p-select
      [options]="streetTypeOptions()"
      [ngModel]="streetType()"
      (ngModelChange)="setStreetType($event)"
      placeholder="-- Seleziona --"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      [showClear]="true"
      styleClass="w-full"
      [disabled]="readonly()"
      [attr.aria-required]="true"
      [attr.aria-invalid]="formSubmitted() && !streetType()"
    />
    @if (formSubmitted() && !streetType()) {
      <small class="text-red-500" role="alert">Campo obbligatorio</small>
    }
  </div>

  <!-- Nome Via -->
  <div class="field col-12 md:col-4">
    <label class="font-semibold block mb-2">
      Nome Via
      <span class="text-red-500" aria-hidden="true">*</span>
    </label>
    <input
      type="text"
      pInputText
      [ngModel]="streetName()"
      (ngModelChange)="setStreetName($event)"
      placeholder="Inserisci nome via"
      class="w-full"
      [disabled]="readonly()"
      [attr.aria-required]="true"
      [attr.aria-invalid]="formSubmitted() && (!streetName() || streetName().trim() === '')"
    />
    @if (formSubmitted() && (!streetName() || streetName().trim() === '')) {
      <small class="text-red-500" role="alert">Campo obbligatorio</small>
    }
  </div>

  <!-- Numero -->
  <div class="field col-12 md:col-4">
    <label class="font-semibold block mb-2">
      Numero
      <span class="text-red-500" aria-hidden="true">*</span>
    </label>
    <input
      type="text"
      pInputText
      [ngModel]="streetNumber()"
      (ngModelChange)="setStreetNumber($event)"
      placeholder="es. 7 o 7/A"
      class="w-full"
      [disabled]="readonly()"
      [attr.aria-required]="true"
      [attr.aria-invalid]="formSubmitted() && !streetNumber()"
    />
    @if (formSubmitted() && !streetNumber()) {
      <small class="text-red-500" role="alert">Campo obbligatorio</small>
    }
  </div>

  <!-- CAP -->
  <div class="field col-12 md:col-4">
    <label class="font-semibold block mb-2">
      CAP
      <span class="text-red-500" aria-hidden="true">*</span>
    </label>
    <input
      type="text"
      pInputText
      [ngModel]="zipCode()"
      (ngModelChange)="setZipCode($event)"
      maxlength="5"
      placeholder="5 cifre"
      class="w-full"
      [disabled]="readonly()"
      [attr.aria-required]="true"
      [attr.aria-invalid]="(formSubmitted() && !zipCode()) || !isValidZipCode(zipCode())"
    />
    @if (formSubmitted() && (!zipCode() || zipCode().trim() === '')) {
      <small class="text-red-500" role="alert">Campo obbligatorio</small>
    }
    @if (zipCode() && zipCode().trim() !== '' && !isValidZipCode(zipCode())) {
      <small class="text-red-500" role="alert">Deve essere di 5 cifre numeriche</small>
    }
  </div>

  <!-- Regione -->
  <div class="field col-12 md:col-4">
    <label class="font-semibold block mb-2">
      Regione
      <span class="text-red-500" aria-hidden="true">*</span>
    </label>
    <p-select
      [options]="regionOptions()"
      [ngModel]="region()"
      (ngModelChange)="onRegionChange($event)"
      placeholder="-- Seleziona Regione --"
      [filter]="true"
      [showClear]="true"
      optionLabel="label"
      optionValue="value"
      styleClass="w-full"
      [disabled]="readonly()"
      [attr.aria-required]="true"
      [attr.aria-invalid]="formSubmitted() && (!region() || region().trim() === '')"
    />
    @if (formSubmitted() && (!region() || region().trim() === '')) {
      <small class="text-red-500" role="alert">Campo obbligatorio</small>
    }
  </div>

  <!-- Provincia -->
  <div class="field col-12 md:col-4">
    <label class="font-semibold block mb-2">
      Provincia
      <span class="text-red-500" aria-hidden="true">*</span>
    </label>
    <p-select
      [options]="provinceOptions()"
      [ngModel]="province()"
      (ngModelChange)="onProvinceChange($event)"
      placeholder="-- Seleziona Provincia --"
      [filter]="true"
      [showClear]="true"
      [disabled]="!region() || readonly()"
      optionLabel="label"
      optionValue="value"
      styleClass="w-full"
      [attr.aria-required]="true"
      [attr.aria-invalid]="formSubmitted() && (!province() || province().trim() === '')"
    />
    @if (formSubmitted() && (!province() || province().trim() === '')) {
      <small class="text-red-500" role="alert">Campo obbligatorio</small>
    }
  </div>

  <!-- Comune -->
  <div class="field col-12 md:col-4">
    <label class="font-semibold block mb-2">
      Comune
      <span class="text-red-500" aria-hidden="true">*</span>
    </label>
    <p-select
      [options]="municipalityOptions()"
      [ngModel]="municipality()"
      (ngModelChange)="setMunicipality($event)"
      placeholder="-- Seleziona Comune --"
      [filter]="true"
      [showClear]="true"
      [disabled]="!province() || readonly()"
      optionLabel="label"
      optionValue="value"
      styleClass="w-full"
      [attr.aria-required]="true"
      [attr.aria-invalid]="formSubmitted() && (!municipality() || municipality().trim() === '')"
    />
    @if (formSubmitted() && (!municipality() || municipality().trim() === '')) {
      <small class="text-red-500" role="alert">Campo obbligatorio</small>
    }
  </div>
</div>
